import { FaRegTrashAlt, FaFileImage } from "react-icons/fa";
import { type FileInputProps } from "./Interfaces";
import { useAttach } from "./useAttch";

export const Attach = ({ label, accept = "image/*", onFilesChange }: FileInputProps) => {
  const helper = useAttach(onFilesChange);

  return (
    <div className="w-full max-w-md">
      <label className="block mb-[10px] font-medium text-gray-700">{label}</label>
      <div className="relative border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center hover:border-blue-400 transition-colors h-[150px]">
        <input
          type="file"
          accept={accept}
          onChange={helper.handleFileChange}
          className="absolute w-full h-full cursor-pointer opacity-0"
        />
        <p className="text-blue-500">Drag files here or click to upload</p>
      </div>

      {helper.files.map((item) => (
        <div
          key={item.name}
          className="flex items-center justify-between w-[95%] mt-[15px] p-[10px] border border-[#b0b8be] rounded-[4px]"
        >
          <div className="flex items-center space-x-2">
            <FaFileImage className="text-[20px] mr-[10px] text-[#2F3941]" />
            <span className="truncate max-w-[250px]">{item.name}</span>
          </div>
          <button
            type="button"
            onClick={() => helper.handleRemoveFile(item)}
            className="hover:text-red-700 bg-[white] border-none text-[20px] flex items-center justify-center"
          >
            <FaRegTrashAlt className="text-[red]" />
          </button>
        </div>
      ))}
    </div>
  );
};
